// extracted by mini-css-extract-plugin
export default {"separator":"RiskRegister_separator__sYhVm","titleFilters":"RiskRegister_titleFilters__W1Akq","actions":"RiskRegister_actions__u8eM1"};